var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "当前考勤明细",
        visible: _vm.visible,
        width: "600px",
        "append-to-body": true,
        center: "",
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
      },
    },
    [
      [
        _vm.records && _vm.records.length > 0
          ? _c(
              "div",
              { staticClass: "stat-list" },
              _vm._l(_vm.records, function (item, index) {
                return _c(
                  "div",
                  {
                    key: index,
                    staticClass: "item-stat",
                    class: [item.validPunch ? "" : "item-stat-dis"],
                  },
                  [
                    _c("span", { staticClass: "name" }, [
                      _vm._v(_vm._s(item.name)),
                    ]),
                    _c("span", { staticClass: "time" }, [
                      _vm._v(_vm._s(item.time)),
                    ]),
                    item.tags && item.tags.length > 0
                      ? _c(
                          "div",
                          { staticClass: "tag" },
                          _vm._l(item.tags, function (tag, index) {
                            return _c(
                              "div",
                              { key: index, staticClass: "tag-gray" },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      tag == "REPAIR"
                                        ? "补卡"
                                        : tag == "OUTSIDE"
                                        ? "外勤"
                                        : tag
                                    ) +
                                    " "
                                ),
                              ]
                            )
                          }),
                          0
                        )
                      : _vm._e(),
                  ]
                )
              }),
              0
            )
          : _c("div", { staticClass: "none-info" }, [_vm._v("暂无记录")]),
      ],
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary" },
              on: {
                click: function ($event) {
                  _vm.visible = false
                },
              },
            },
            [_vm._v(_vm._s(_vm.buttonText))]
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }